export default class Tabs {
  constructor(selector) {
    this.tabsActive = 'active';

    // If there is no element, return
    this.element = document.getElementById(selector);

    if (this.element == null) return;

    this.element.addEventListener('click', this.click, false);
  }

  click() {
    event.preventDefault();

    const elAnchor = event.target.closest('a');

    // Which pane do we want to show
    let openTabPane = document.getElementById(elAnchor.href.split('#')[1]);

    // Find all active tab panes that are siblings to the pane we want to show
    let openSiblingTabPanes = openTabPane.parentElement.querySelectorAll('.active');

    openSiblingTabPanes.forEach(function (tab) {
      tab.className = tab.className.replace('active', '');
    });

    // Find all active tabs and remove the active class
    let activeTabs = elAnchor.parentElement.parentElement.querySelectorAll('.active');

    activeTabs.forEach(function (tab) {
      tab.className = tab.className.replace('active', '');
    });

    // Activate new tab and panel
    elAnchor.parentElement.className += ' active';
    openTabPane.classList.add('active');
  }
}
